import React, { useState, useEffect, useRef, useContext } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { useNavigate, Route, Routes, Link, Navigate, useLocation, useParams } from 'react-router-dom';
import Social from './Social';
import Music from './Music';
import MusicOG from './MusicOG';
import MusicSeeAll from './MusicSeeAll'; 
import MovieView from './MovieView';
import VideoSeeAll from './VideoSeeAll';
import SpncastMoreCategories from './SpncastMoreCategories';
import Library from './Library';
import Video from './Video';
import MYDAT from './MYDAT';
import { ProfilesDisplaySearchdat } from './ProfilesDisplaySearchdat';
import ProfilesDisplayShareCredits from './ProfilesDisplayShareCredits';
import PostScreen from './PostScreen';
import NotificationsScreen from './NotificationsScreen';
import SPNSKN from './SPNSKN';
import ViewPostScreen from './ViewPostScreen';
import messagingIcon from './assets/messagingIcon.png';
import topIconProfile2 from './assets/topIconProfile2.png';
import notificationBell from './assets/notificationBell.png';
import postingIcon from './assets/postingIcon.png';
import searchdat from './assets/searchdat.png';
import searchdatHover from './assets/searchdatHover.png';
import searchIcon from './assets/topIconSearchIcon2.png';
import ArtistIconCredits from './assets/ArtistIconCredits.png';
import PlayButton from './assets/PlayButton.png';
import PauseButton from './assets/PauseButton.png';
import NextSongIcon from './assets/nextSongIcon.png';
import PreviousSongIcon from './assets/previousSongIcon.png';
import unread from './assets/unreadMain.png';
import topFade from './assets/topFade2.png';
import bottomFade from './assets/bottomFade2.png';
import tinyCloseButton from './assets/tinyCloseButton.png'; // Import the close button image
import { AppContext } from './AppContext'; 
import SongDetails from './SongDetails';
import SongDetailsPlaying from './SongDetailsPlaying';
import MYDATUser from './MYDATUser';
import ScreenSKNowned from './ScreenSKNowned';
import { getFirestore, setDoc, deleteDoc, where, query, writeBatch, getDocs, doc, deleteField, collection, updateDoc, getDoc, onSnapshot } from 'firebase/firestore';
import LivestreamPage from './LivestreamPage';
import CustomLivestreamPlayer from './CustomLivestreamPlayer';
import { StreamVideo, StreamCall } from '@stream-io/video-react-sdk';
import LivestreamView from './LivestreamView';
import ChatDisplay from './ChatDisplay';
import ChatInput from './ChatInput';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { getFunctions, httpsCallable } from 'firebase/functions';
import LoginScreen from './LoginScreen';
import SignupScreen from './SignupScreen';
import PrivacyPolicy from './PrivacyPolicy'; 
import VideoListScreen   from './VideoListScreen';     // “Wallet” landing
import VideoDetailScreen from './VideoDetailScreen';   // DAT detail / sell
import WalletAnalytics   from './WalletAnalytics';     // charts (uses WalletChart)
import NFTDetail from './NFTDetail'; 
import CategoriesScreen2 from './CategoriesScreen2';
import PasswordChange from './PasswordChange';
import PersonalInfo from './PersonalInfo';
import Report from './Report';
import Terms from './Terms';
import DeactivateAccount from './DeactivateAccount';
import TheFollowersPage from './TheFollowersPage';
import LikedDatsScreen from './LikedDatsScreen';

import ReleaseMusic from './ReleaseMusic';

import EarningsPage from './EarningsPage';
import RemoveReleasesPage from './RemoveReleasesPage';

import AnalyticsPage from './AnalyticsPage'; 
import SupportPage from './SupportPage';
import ShowcaseArtistView from './ShowcaseArtistView';
import Showcase from './Showcase';

const AppWrapped = ({ clientSecret, setClientSecret, isMFAEnabled, setIsMFAEnabled, user, setNavigateRefreshHandler }) => {
  const auth = getAuth();
  const { setLikes, setReposts, hasUnread, hasUnreadNotifications, playPreviousSong, playNextSong, isPlaylist, handleCloseClick, creditsIOS, miniPlayer, togglePlayPause, isPlaying, setMiniPlayer, audioRef,
    callId,
    client,
    clientView,
    callIdView,
    call,
    setParticipants,
    isChatHidden,
    setIsChatHidden, 
    hideViewers,
    setHideViewers,
    isLivestreamEnded,
    setIsLivestreamEnded,
    isViewingLivestream,
    setIsViewingLivestream,
    participants,
    setCallIdView,
    setClientView,
    startLivestream,
    stopLivestream, handleHideViewers, handleHideChat, livestreamingVisible, setLivestreamingVisible, userId2,
    totalDatTokens
   } = useContext(AppContext);
  const location = useLocation();
  const [contentBottomMargin, setContentBottomMargin] = useState(0);
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(false);

  const [showMFAPrompt, setShowMFAPrompt] = useState(false);

  const navigate = useNavigate();

  const [hoveredLink, setHoveredLink] = useState(null);
  const [isSearchHovered, setIsSearchHovered] = useState(false);
  const [isCreditsHovered, setIsCreditsHovered] = useState(false);
  const [isSpnsknHovered, setIsSpnsknHovered] = useState(false);



  

  const functions = getFunctions();

  const appearance = {
    theme: 'stripe', // Stripe's built-in theme
    variables: {
      fontFamily: 'Arial, sans-serif',
      fontLineHeight: '1.5',
      borderRadius: '4px',
      colorBackground: '#fff',
      colorText: '#30313d',
      colorPrimary: '#635bff',
      colorDanger: '#df1b41',
    },
    rules: {
      '.Input': {
        border: '1px solid #ccc',
        padding: '10px',
        fontSize: '16px',
      },
      '.Input:focus': {
        borderColor: '#635bff',
        boxShadow: '0 0 0 1px #635bff',
      },
      '.Label': {
        fontSize: '14px',
        color: '#555',
      },
    },
  };
  
  const options = {
    clientSecret, // Your clientSecret here
    appearance,   // Appearance configuration
  };

  const handlePressBegins = (miniPlayer) => {
    const clonedSong = JSON.parse(JSON.stringify(miniPlayer));
    navigate(`/dat/${clonedSong.id}`, { state: { clonedSong } });
  };

  useEffect(() => {
    const db = getFirestore();
    const auth = getAuth();
    const currentUser = auth.currentUser;
  
    if (!currentUser) {
      return;
    }
  
    const userId = currentUser.uid;
  
    const fetchClientSecret = async () => {
      try {
        const createPaymentIntent = httpsCallable(functions, 'createPaymentIntent');
        const response = await createPaymentIntent({
          priceId: 'price_1QaPxgBqCybQOhrecA8YY5iJ', // Lowest priceId
        });
        setClientSecret(response.data.clientSecret);
      } catch (error) {
        console.error('Error fetching client secret:', error);
      }
    };
  
    const fetchUserLikesSummary = async () => {
      // Instead of querying the subcollection, fetch the likes summary document.
      const likesSummaryRef = doc(db, 'socialSummaryLikes', userId);
      const docSnap = await getDoc(likesSummaryRef);
      if (docSnap.exists()) {
        setLikes(docSnap.data().likes || {});
      } else {
        setLikes({});
      }
    };
  
    const fetchUserRepostsSummary = async () => {
      // Similarly, fetch the reposts summary document.
      const repostsSummaryRef = doc(db, 'socialSummaryReposts', userId);
      const docSnap = await getDoc(repostsSummaryRef);
      if (docSnap.exists()) {
        setReposts(docSnap.data().reposts || {});
      } else {
        setReposts({}); 
      }
    };
  
    fetchUserLikesSummary();
    fetchUserRepostsSummary();
  
    fetchClientSecret();

  }, []);
  

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const source = searchParams.get('source');
    const path = location.pathname;

    if (source === 'app' && path.includes('/mydat/profile/')) {
      const username = path.split('/mydat/profile/')[1];
      if (username) {
        window.location.href = `myapp://profile/${username}`;
      }
    }
  }, [location]);

  useEffect(() => {
    if (miniPlayer?.ArtworkURL) {
      setContentBottomMargin('100%'); // Adjust this value based on the height of your miniPlayerBar
    } else {
      setContentBottomMargin('100%');
    }
  }, [miniPlayer]);

  const textRef = useRef(null);
  const iconRef = useRef(null);
  const centeredViewRef = useRef(null);

  const [contentWidth, setContentWidth] = useState(0);
  const [iconWidth, setIconWidth] = useState(0);

  useEffect(() => {
    if (textRef.current && iconRef.current) {
      setContentWidth(textRef.current.offsetWidth);
      setIconWidth(iconRef.current.offsetWidth);
    }
  }, [creditsIOS]);


  

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleCreditsClick = () => {
    if (userId2 === "guest") {
      navigate('/login');
    } else {
      navigate('/credits');
    }
  };
  
  const handlePostingIconClick = () => {
    if (userId2 === "guest") {
      navigate('/login');
    } else {
      navigate('/post');
    }
  };
  
  const handleNotificationClick = () => {
    if (userId2 === "guest") {
      navigate('/login');
    } else {
      navigate('/notifications');
    }
  };
  
  const handleMessagingIconClick = () => {
    if (userId2 === "guest") {
      navigate('/login');
    } else {
      navigate('/spnskn');
    }
  };

  const handleProfileIconClick = () => {
    if (userId2 === "guest") {
      navigate('/login');
    } else {
      navigate('/mydat');
    }
  };
  




  const styles = {
    container: {
      backgroundColor: '#0e061e',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'hidden',
      marginLeft: '0',
      
    },
    header: {
      width: '100%',
      maxWidth: '480px',
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '10px',
      backgroundColor: 'transparent',
    },
    signOutButton: {
      backgroundColor: '#62fbfa',
      border: 'none', 
      color: 'black',
      padding: '10px 20px',
      borderRadius: '5px',
      cursor: 'pointer',
      fontSize: '1rem',
    },
    centeredView: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center', 
      position: 'fixed',
      top: '18px',
      maxWidth: '480px',
      right: 'max(16px, calc((100vw - 480px) / 2 + 16px))',
      zIndex: 2,
      backgroundColor: 'transparent',
    },
    
    
    headerTop: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignSelf: 'center',
      alignItems: 'center',
      position: 'fixed',
      top: '30px',
      maxWidth: '480px',
      width: '480px',
      zIndex: 2,
    },
    navbar: {
      display: 'flex',
      justifyContent: 'space-around',
      width: '100%',
      backgroundColor: 'transparent',
      padding: '5px 0',
      position: 'fixed',
      top: '54px',
      zIndex: 2,
      alignSelf: 'center',
      alignItems: 'center',
      maxWidth: '480px',
    },
    iconBar: {
      display: 'flex',
      justifyContent: 'flex-start',
      gap: '28px',
      position: 'fixed',
      top: '18px',                        // ⬅ same vertical row as the credits
      left:  'max(16px, calc(50% - 222px))',
      width: 'auto',                      // no full-width stretch
      backgroundColor: 'transparent',
      maxWidth: '480px',
      zIndex: 2,
    },
    
    
    iconContainer: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      cursor: 'pointer',
      width: '25px',
      height: '25px',
    },
    iconUnread: {
      position: 'absolute',
      top: '0px', // Adjust this to fine-tune positioning
      right: '20px', // Adjust this to fine-tune positioning
      width: '10px',
      height: '10px',
    },
    iconUnreadNotifications: {
      position: 'absolute',
      top: '4px', // Adjust this to fine-tune positioning
      right: '4px', // Adjust this to fine-tune positioning
      width: '10px',
      height: '10px',
    },
    navLink: {
      color: 'white',
      textDecoration: 'none',
      fontSize: '18px',
      fontFamily: 'brhendrix',
      transition: 'color 0.3s',
      zIndex: 2000000,
    },
    navLinkHovered: {
      color: '#62fbfa',
      zIndex: 2000000,
    },
    content: {
      maxWidth: '480px',
      alignSelf: 'center',
      marginTop: '87px',
      flex: 1,
      overflowY: 'none',
      width: '100%',
      position: 'fixed',
      height: contentBottomMargin,
      borderLeft: '2px solid #62fbfa',
      borderRight: '2px solid #62fbfa',
    },
    miniPlayerBar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'fixed',
      bottom: 0,
      width: '100%',
      backgroundColor: '#0e061e',
      border: '1px solid rgba(23, 195, 250, 0.5)',
      padding: '10px',
    },
    artwork: {
      width: '50px',
      height: '50px',
      borderRadius: '5px',
    },
    songInfo: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: '10px',
      justifyContent: 'center',
    },
    songInfoContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginLeft: '5px',
    },
    artistName: {
      color: 'white',
      fontSize: '1rem',
    },
    songName: {
      color: 'white',
      fontSize: '0.8rem',
    },
    controlButtons: {
      display: 'flex',
      alignItems: 'center',
    },
    playPauseButton: {
      width: '25px',
      height: '25px',
      cursor: 'pointer',
      marginRight: '15px',
    },
    searchLink: {
      color: '#62fbfa',
      display: 'flex',
      marginLeft: '0px',
      textDecoration: 'none',
      fontSize: '18px',
      backgroundColor: 'transparent',
      fontFamily: 'brhendrix',
    },
    spnsknLink: {
      color: 'white',
      display: 'flex',
      marginLeft: '230px',
      textDecoration: 'none',
      fontSize: '18px',
      backgroundColor: 'transparent',
      fontFamily: 'brhendrix',
      transition: 'color 0.3s',
    },
    spnsknLinkHovered: {
      color: '#62fbfa',
      display: 'flex',
      marginLeft: '230px',
      textDecoration: 'none',
      fontSize: '18px',
      backgroundColor: 'transparent',
      fontFamily: 'brhendrix',
    },
    iconSearch: {
      cursor: 'pointer',
      width: '55px',
      height: '30px',
    },
    closeButton: {
      width: '30px',
      height: '30px',
      cursor: 'pointer',
      marginRight: '5px',
    },
    topFade: {
      width: '100%',
      height: '260px',
      position: 'fixed',
      top: 0,
      zIndex: 1,
      pointerEvents: 'none',
    },
    bottomFade: {
      position: 'fixed',
      bottom: 0,
      width: '100%',
      height: '120px',
      pointerEvents: 'none',
    },
  };
  const activeLink = {
    social:  location.pathname.startsWith('/social'),
    music:   location.pathname === '/',
    library: location.pathname.startsWith('/library'),
    dats:    location.pathname.startsWith('/dats'),
    wallet:  location.pathname.startsWith('/wallet'),
  };  

// in AppWrapped.jsx (keep your imports)
// in AppWrapped.jsx
// DATBySlug (drop-in replacement)

const DATBySlug = React.memo(function DATBySlug() {
  const { username, slug } = useParams();
  const { assetsSummary } = React.useContext(AppContext);

  const toSlug = (s = '') =>
    String(s).trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
  const stripAt = (s = '') => String(s).replace(/^@/, '').toLowerCase();

  // Freeze a stable snapshot of assetsSummary for this route to avoid churn-caused flicker
  const summarySnapRef = React.useRef(null);
  if (Array.isArray(assetsSummary) && assetsSummary.length) {
    // only replace the snapshot if size changed (cheap heuristic)
    if (!summarySnapRef.current || summarySnapRef.current.length !== assetsSummary.length) {
      summarySnapRef.current = assetsSummary;
    }
  }

  const candidate = React.useMemo(() => {
    const list = summarySnapRef.current || assetsSummary; // prefer the stable snapshot
    if (!username || !slug || !list?.length) return null;
    const uname = stripAt(username);
    return (
      list.find(a =>
        stripAt(a.creatorUsername || a.username || a.ArtistNameUsername || '') === uname &&
        toSlug(a.SongName || a.title || '') === slug.toLowerCase()
      ) || null
    );
  }, [username, slug, assetsSummary]); // keep deps so it updates when route actually changes

  // Latch before paint so there's no frame where placeholder shows
  const [resolved, setResolved] = React.useState(null);
  React.useLayoutEffect(() => {
    if (candidate && !resolved) setResolved(candidate);
    // IMPORTANT: do not clear resolved if candidate becomes null later
  }, [candidate, resolved]);

  // Don’t render anything until we have the resolved item
  if (!resolved) return null;

  const stableKey = resolved.contentId || resolved.id;
  return <NFTDetail key={stableKey} initialNFT={resolved} />;
});





  return (
    <div style={styles.container}>
      <div style={styles.header}></div>
      <div style={styles.headerTop}>

        <div
          ref={centeredViewRef}
          style={styles.centeredView}
          onClick={handleCreditsClick}
          onMouseEnter={() => setIsCreditsHovered(true)}
          onMouseLeave={() => setIsCreditsHovered(false)}
        >
          <span
            ref={textRef}
            style={{
              color: isCreditsHovered ? '#62fbfa' : 'white',
              fontFamily: 'brhendrix',
              textAlign: 'right',
              justifyContent: 'center',
              alignSelf: 'center',
              marginRight: '3px',
              fontSize: '20px',
              cursor: 'pointer',
            }}
          >
            {typeof totalDatTokens === "number"
    ? (totalDatTokens === 0 ? "ADD" : totalDatTokens.toLocaleString())
    : totalDatTokens}
          </span>
          <img
            ref={iconRef}
            src={ArtistIconCredits}
            alt="Artist Icon Credits"
            style={{
              opacity: 1,
              position: 'relative',
              bottom: '3%',
              marginBottom: '4px',
              width: '25px',
              height: '25px',
              resizeMode: 'contain',
              cursor: 'pointer',
            }}
          />
        </div>

      </div>
      <div style={styles.navbar}>

      <Link
  to={userId2 === 'guest' ? '/login' : '/social'}
  style={{
    ...styles.navLink,
    ...((hoveredLink === 'social' || activeLink.social) ? styles.navLinkHovered : {}),
  }}
  onMouseEnter={() => setHoveredLink('social')}
  onMouseLeave={() => setHoveredLink(null)}
>
  SOCIAL
</Link>

<Link
  to="/"
  style={{
    ...styles.navLink,
    ...((hoveredLink === 'music' || activeLink.music) ? styles.navLinkHovered : {}),
  }}
  onMouseEnter={() => setHoveredLink('music')}
  onMouseLeave={() => setHoveredLink(null)}
>
  MUSIC
</Link>

<Link
  to={userId2 === 'guest' ? '/login' : '/library'}
  style={{
    ...styles.navLink,
    ...((hoveredLink === 'library' || activeLink.library) ? styles.navLinkHovered : {}),
  }}
  onMouseEnter={() => setHoveredLink('library')}
  onMouseLeave={() => setHoveredLink(null)}
>
  LIBRARY
</Link>

<Link
  to={userId2 === 'guest' ? '/login' : '/dats'}
  style={{
    ...styles.navLink,
    ...((hoveredLink === 'dats' || activeLink.dats) ? styles.navLinkHovered : {}),
  }}
  onMouseEnter={() => setHoveredLink('dats')}
  onMouseLeave={() => setHoveredLink(null)}
>
  DATS
</Link>

<Link
  to={userId2 === 'guest' ? '/login' : '/wallet'}
  style={{
    ...styles.navLink,
    ...((hoveredLink === 'wallet' || activeLink.wallet) ? styles.navLinkHovered : {}),
  }}
  onMouseEnter={() => setHoveredLink('wallet')}
  onMouseLeave={() => setHoveredLink(null)}
>
  WALLET
</Link>


      </div>
      <div style={styles.iconBar}>
      <div style={styles.iconContainer}>
  <img
    src={searchIcon}
    alt="Search"
    style={styles.icon}                       // 30 × 30 — shows only the glass
    onClick={() => navigate('/profiles-display-searchdat')}
    onMouseEnter={() => setIsSearchHovered(true)}
    onMouseLeave={() => setIsSearchHovered(false)}
  />
</div>
        <div style={styles.iconContainer}>
          <img src={notificationBell} alt="Notifications" style={styles.icon} onClick={handleNotificationClick} />
          {hasUnreadNotifications && (
            <img src={unread} style={styles.iconUnreadNotifications} />
          )}
        </div>
        <div style={styles.iconContainer}>
          <img src={postingIcon} alt="Post" style={styles.icon} onClick={handlePostingIconClick} />
        </div>
        <div style={styles.iconContainer}>
          <img src={messagingIcon} alt="Messages" style={styles.icon} onClick={handleMessagingIconClick} />
          {hasUnread && (
            <img src={unread} style={styles.iconUnread} />
          )}
        </div>
        <div style={styles.iconContainer}>
          <img src={topIconProfile2} alt="Post" style={styles.icon} onClick={handleProfileIconClick} />
        </div>
      </div>
      <div style={styles.content}> 
        <Routes>
          <Route path="/music/dats/:username/:slug" element={<DATBySlug />} />

          <Route path="/social" element={<Social />} />
          <Route path="/dats/*" element={<Music />} />
          <Route path="/" element={<MusicOG />} />
          <Route path="/music-all" element={<MusicSeeAll />} />
          <Route path="/videoseeall" element={<VideoSeeAll />} />
          <Route path="/spncastmorecategories" element={<SpncastMoreCategories />} />
          <Route path="/movieview" element={<MovieView />} />
          <Route path="/cashout" element={<EarningsPage />} />
                    <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/mydat/settings/removereleases" element={<RemoveReleasesPage />} />
          <Route path="/library/*" element={<Library />} />
          <Route path="/library/liked" element={<LikedDatsScreen />} />
          <Route path="/video" element={<Video />} />
          <Route path="/dat/:datId" element={<NFTDetail />} />

          <Route path="/wallet" element={<VideoListScreen />} />               {/* list of owned DATs */}
  <Route path="/wallet/dat/:datId" element={<VideoDetailScreen />} />  {/* single DAT detail */}
  <Route path="/wallet/analytics/:datId" element={<WalletAnalytics />} /> {/* charts */}

  <Route path="/mydat/settings" element={<CategoriesScreen2 />} />
  <Route path="/mydat/settings/password" element={<PasswordChange />} />
  <Route path="/mydat/settings/personalinfo" element={<PersonalInfo />} />
  <Route path="/mydat/settings/report" element={<Report />} />
    <Route path="/mydat/settings/support" element={<SupportPage />} />
  <Route path="/mydat/settings/terms" element={<Terms />} />
  <Route path="/mydat/settings/deactivateaccount" element={<DeactivateAccount />} />
  <Route path="/mydat/followers" element={<TheFollowersPage />} />
          <Route path="/mydat/*" element={<MYDAT isMFAEnabled={isMFAEnabled} setIsMFAEnabled={setIsMFAEnabled} setShowMFAPrompt={setShowMFAPrompt} />} />
          <Route
  path="/credits"
  element={
    <ProfilesDisplayShareCredits 
      clientSecret={clientSecret}  
      setClientSecret={setClientSecret} 
    />
  }
/>

          <Route path="/post" element={<PostScreen />} />
          <Route path="/livestream" element={<LivestreamPage />} />
          <Route path="/notifications" element={<NotificationsScreen />} />
          <Route path="/spnskn" element={<SPNSKN />} />
                              <Route path="/showcase" element={<Showcase />} />
                    <Route path="/showcase/:username" element={<ShowcaseArtistView />} />
          <Route path="/releasemusic" element={<ReleaseMusic />} />
          <Route path="/viewpost" element={<ViewPostScreen />} />
          <Route path="/view-song" element={<SongDetails />} />
          <Route path="/view-song-playing" element={<SongDetailsPlaying />} />
          <Route path="/userprofile/:username" element={<MYDATUser />} />
          <Route path="/profiles-display-searchdat" element={<ProfilesDisplaySearchdat />} /> {/* Added the search route */}
          <Route path="/screensknowned" element={<ScreenSKNowned />} />

            <Route
              path="/login"
              element={
                <LoginScreen
                  setIsMFAEnabled={setIsMFAEnabled}
                  showMFAPrompt={showMFAPrompt}
                  setShowMFAPrompt={setShowMFAPrompt}
                />
              }
            />
            <Route
              path="/signup"
              element={<SignupScreen setShowMFAPrompt={setShowMFAPrompt} />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/mydat/profile/:username"
              element={<Navigate to="/login" />}
            />
            <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </div>
      <img src={topFade} style={styles.topFade} alt="Top Fade" />
      <img src={bottomFade} style={styles.bottomFade} alt="Bottom Fade" />
      {miniPlayer?.ArtworkURL && (
        <div style={styles.miniPlayerBar}>
          <div style={styles.songInfoContainer} onClick={() => handlePressBegins(miniPlayer)}>
            <img src={miniPlayer.ArtworkURL} alt="Artwork" style={styles.artwork} />
            <div style={styles.songInfo}>
              <span style={styles.artistName}>{miniPlayer.ArtistName}</span>
              <span style={styles.songName}>{miniPlayer.SongName}</span>
            </div>
          </div>
          <div style={styles.controlButtons}>
            {isPlaylist && (
              <img
                src={PreviousSongIcon}
                style={styles.playPauseButton}
                onClick={playPreviousSong}
              />
            )}
            <img
              src={isPlaying ? PauseButton : PlayButton}
              alt={isPlaying ? 'Pause' : 'Play'}
              style={styles.playPauseButton}
              onClick={togglePlayPause}
            />
            {isPlaylist && (
              <img
                src={NextSongIcon}
                style={styles.playPauseButton}
                onClick={playNextSong}
              />
            )}
            <img
              src={tinyCloseButton}
              alt="Close"
              style={styles.closeButton}
              onClick={handleCloseClick}
            />
          </div>
        </div>
      )}
      {livestreamingVisible && (
          <div style={{ zIndex: '1000', position: 'relative', height: '100vh', backgroundColor: 'transparent' }}>
      {callId && client && (
        <>
          <StreamVideo client={client}>
            <StreamCall call={call}>
              <div style={{ height: '100%', backgroundColor: 'black', zIndex: 10 }}>
                <LivestreamView
                  participants={participants}
                  isChatHidden={isChatHidden}
                  handleHideChat={handleHideChat}
                  hideViewers={hideViewers}
                  handleHideViewers={handleHideViewers}
                  call={call}
                  onStopLive={stopLivestream}
                />
              </div>
            </StreamCall>
          </StreamVideo>

          <button
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              padding: '10px',
              backgroundColor: 'rgba(81, 33, 131, 0.7)',
              color: 'white',
              borderRadius: '5px',
              border: 'none',
              cursor: 'pointer',
              zIndex: 20,
            }}
            onClick={handleHideChat}
          >
            {isChatHidden ? 'Show Chat' : 'Hide Chat'}
          </button>

          {!isChatHidden && (
            <>
              {/* ChatDisplay */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '14%',
                  width: '100%',
                  height: '30%',
                  zIndex: 200,
                }}
              >
                <ChatDisplay
                 callId={callId}
                />
              </div>

              {/* ChatInput */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '10%',
                  width: '100%',
                  zIndex: 20,
                }}
              >
                <ChatInput
                  isKeyboardVisible={isKeyboardVisible}
                  callId={callId}
                />
              </div>
            </>
          )}
        </>
      )}
    </div>
      )}
            {isViewingLivestream && (
          <div style={{ zIndex: '1000', position: 'relative', height: '100vh', backgroundColor: 'transparent' }}>

        <>
          <StreamVideo client={client}>
              <div style={{ height: '100%', backgroundColor: 'black', zIndex: 10 }}>
                <CustomLivestreamPlayer
                  participants={participants}
                  isChatHidden={isChatHidden}
                  handleHideChat={handleHideChat}
                  hideViewers={hideViewers}
                  handleHideViewers={handleHideViewers}
                  call={call}
                  onStopLive={stopLivestream}
                />
              </div>

          </StreamVideo>

          <button
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              padding: '10px',
              backgroundColor: 'rgba(81, 33, 131, 0.7)',
              color: 'white',
              borderRadius: '5px',
              border: 'none',
              cursor: 'pointer',
              zIndex: 20,
            }}
            onClick={handleHideChat}
          >
            {isChatHidden ? 'Show Chat' : 'Hide Chat'}
          </button>

          {!isChatHidden && (
            <>
              {/* ChatDisplay */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '14%',
                  width: '100%',
                  height: '30%',
                  zIndex: 200,
                }}
              >
                <ChatDisplay
                 callId={callIdView}
                />
              </div>

              {/* ChatInput */}
              <div
                style={{
                  position: 'absolute',
                  bottom: '10%',
                  width: '100%',
                  zIndex: 20,
                }}
              >
                <ChatInput
                  isKeyboardVisible={isKeyboardVisible}
                  callId={callIdView}
                />
              </div>
            </>
          )}
        </>

    </div>
      )} 
    </div>
    
  );
};

export default AppWrapped;
 